export const types = {
  // Sync
  SHOW_REACHED_LIMIT_MODAL: "SHOW_REACHED_LIMIT_MODAL",
  HIDE_REACHED_LIMIT_MODAL: "HIDE_REACHED_LIMIT_MODAL",
};
